<template>
  <div class="HolidayDetails">
    <v-row>
      <v-col cols="12" sm="6"
        >{{ $t("PeriodWorkDetails.HolidayDetails.lblTatilMotalegheSat") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.HG_MINUTES) }}</span
        ></v-col
      >
      <v-col cols="12" sm="6"
        >{{ $t("PeriodWorkDetails.HolidayDetails.lbltatilMotalegheRoz") }}:<span
          class="text-value"
          >{{ details.HG_DAYS }}</span
        ></v-col
      >
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.HolidayDetails.lblKasrTatilMoatalegheSat")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.HT_MINUTES)
        }}</span></v-col
      >
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.HolidayDetails.lblKasrTatilMoatalegheRoz")
        }}:<span class="text-value">{{ details.HT_DAYS }}</span></v-col
      >
      <v-col cols="12" sm="6"
        >{{
          $t(
            "PeriodWorkDetails.HolidayDetails.lblMeghdartakhireBakhshideShode"
          )
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.FORGIVEN_LATEAMOUNT)
        }}</span></v-col
      >
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.HolidayDetails.lblTedadeTakhireBakhshideShode")
        }}:<span class="text-value">{{
          details.FORGIVEN_LATECOUNT
        }}</span></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["details"],
};
</script>

<style>
</style>